import { CheckIcon, ShieldCheckIcon, ZapIcon, FileTextIcon } from "lucide-react";
import { CountdownUrgency } from "./CountdownUrgency";
import { CTAButton } from "./CTAButton";
import { CHECKOUT_URL } from "../data/content";
const ORDER_ITEMS = ["6 tomos completos de psicología deportiva (PDF)", "Bono 1 — Cuaderno de Visualización Guiada", "Bono 2 — Excel: Tracker de Estado Mental", "Bono 3 — Baraja de 40 Tarjetas de Reencuadre", "Bono 4 — Excel: Diario de Objetivos SMART", "Bono 5 — Protocolo Anti-Choke imprimible", "Bono 6 — Checklist de Rutina Precompetitiva"];
export function FinalOffer() {
  const buy = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <section id="compra" className="scroll-mt-4 px-5 pt-12" data-id="element-98" data-mp="1v5bb6mumslw0">
      <div className="rounded-3xl border-2 border-blue-700 bg-white/95 p-5 shadow-xl backdrop-blur" data-id="element-99" data-mp="1v5tg07vd08fj">
        <h2 className="text-center text-2xl font-black text-blue-950" data-id="element-100" data-mp="295cesa2a67f6">
          Kit completo de psicología deportiva
        </h2>
        <p className="mt-1 text-center text-sm text-gray-600" data-id="element-101" data-mp="1pgo5rkb4r6k">
          6 tomos + 6 bonos exclusivos · 100 % digital
        </p>

        {/* Urgencia: cuenta atrás + plazas */}
        <div className="mt-5" data-id="element-102" data-mp="6qmifttm8mi7">
          <CountdownUrgency data-id="element-103" data-mp="bnwdpq3orsdy" />
        </div>

        {/* Resumen de compra */}
        <div className="mt-5 rounded-2xl border border-blue-100 bg-blue-50/60 p-4" data-id="element-104" data-mp="bpze942gt3wx">
          <p className="text-sm font-extrabold uppercase tracking-wide text-blue-950" data-id="element-105" data-mp="gkmt0b7o2jyb">
            Resumen de la compra
          </p>
          <ul className="mt-3 space-y-2" data-id="element-106" data-mp="pn4icyimbspj">
            {ORDER_ITEMS.map(item => <li key={item} className="flex items-start gap-2" data-id="element-107" data-mp="ue4brtsj3sna">
                <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-green-600" data-id="element-108" data-mp="uew9pb9lm2gq" />
                <span className="text-sm leading-snug text-gray-700" data-id="element-109" data-mp="14ck583f13dzy">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-3 border-t border-blue-100 pt-3 text-center text-xs font-bold uppercase text-green-600" data-id="element-110" data-mp="18e5d1acph23a">
            🎁 Bonos GRATIS solo por hoy
          </p>
        </div>

        {/* Precio */}
        <div className="mt-6 text-center" data-id="element-111" data-mp="30dc64hibeblb">
          <p className="text-base font-semibold text-gray-400 line-through" data-id="element-112" data-mp="3e73f9os4vtgi">
            $50
          </p>
          <p className="text-5xl font-black text-blue-950" data-id="element-113" data-mp="39fv8l0i6um71">$20</p>
          <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-red-600" data-id="element-114" data-mp="3o510e3ep5a4w">
            Pago único · Ahorras $30 hoy
          </p>
        </div>

        {/* Botón de compra -> checkout */}
        <div className="mt-6" data-id="element-115" data-mp="10biubgq7lwq">
          <CTAButton label="Quiero mejorar mi mentalidad" onClick={buy} data-id="element-116" data-mp="za3husogd97" />
        </div>

        {/* Garantías */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-gray-500" data-id="element-117" data-mp="3t5fb5t7omy6m">
          <span className="flex items-center gap-1" data-id="element-118" data-mp="22rybehg9novb">
            <FileTextIcon size={14} className="text-blue-600" data-id="element-119" data-mp="1yql1nwa1z1j4" /> 100 % PDF
          </span>
          <span className="flex items-center gap-1" data-id="element-120" data-mp="1omeitag1crui">
            <ZapIcon size={14} className="text-blue-600" data-id="element-121" data-mp="1omxz6mq1f86f" /> Entrega inmediata
          </span>
          <span className="flex items-center gap-1" data-id="element-122" data-mp="1sn8744xe48nx">
            <ShieldCheckIcon size={14} className="text-blue-600" data-id="element-123" data-mp="1ewuxly4uolwh" /> Pago seguro
          </span>
        </div>
      </div>
    </section>;
}